"use strict";

import angular from "angular";

angular.module("nucont.privacyPolicy").config(["$stateProvider", routeConfig]);

/** Página aberta: visitante e usuário logado (qualquer perfil) leem a mesma política. */
function routeConfig($stateProvider) {
    $stateProvider.state("nucont.privacyPolicy", {
        url: "politica-de-privacidade",
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-privacy-policy" */ "./privacy-policy.component"
            ).then(() => $ocLazyLoad.inject("nucont.privacyPolicy"));
        },
        views: {
            "main@": {
                component: "emptyLayoutComponent"
            },
            "empty@nucont.privacyPolicy": {
                component: "privacyPolicyComponent"
            }
        },
        bodyClass: "privacy-policy-module"
    });
}
